import { useEffect, useRef } from "react";
import "./searchInput.css";
import { setFontSize } from "../utils/fonts";

const SearchInput = () => {
  const inputRef = useRef();

  const resizer = () => {
    setFontSize(inputRef.current, 4);
    const notebookIcon = document.querySelector(".notebook-icon");
    if (notebookIcon) {
      const notebookIconDim = notebookIcon.getBoundingClientRect();
      inputRef.current.style.height = `${notebookIconDim.height}px`;
    }
  };

  window.addEventListener("resize", resizer);

  useEffect(() => {
    const notebookIcon = document.querySelector(".notebook-icon");
    if (notebookIcon) {
      const notebookIconDim = notebookIcon.getBoundingClientRect();
      inputRef.current.style.height = `${notebookIconDim.height}px`;
      setFontSize(inputRef.current, 3);
    }
    return () => window.removeEventListener("resize", resizer);
  }, []);

  return <textarea className="search-input" ref={inputRef} />;
};

export default SearchInput;
